module.exports = __webpack_public_path__ + "static/Unity_Tower_lower_floor_traditional_v2-9e5509d8162e910f9f923825a3ed8da4.png";